/* eslint-disable id-match */
import PropTypes from 'prop-types';
import { createSliderWithTooltip, Range } from 'rc-slider';
import React, { useContext } from 'react';
import ThemeContext from '../../../../providers/ThemeProvider';

const RcRange = createSliderWithTooltip(Range);

const BookingRangeSlider = ({ onRangeChange, title }) => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <h4 className="slider-title">{title}</h4>
      <div className="slider-container">
        <RcRange
          allowCross={false}
          defaultValue={[0, 24]}
          max={24}
          min={0}
          onAfterChange={(value_) => {
            onRangeChange(value_);
          }}
          tipFormatter={(value) => `${value}:00`}
          tipProps={{ visible: true }}
        />
      </div>
      <style jsx>{`
        .slider-container {
          margin: 0 15px;
        }
        .slider-title {
          color: ${theme.commoncolors.greyshade};
        }
        :global(.rc-slider) {
          margin-bottom: 15px;
          margin-top: 25px;
        }
        :global(.rc-slider-track) {
          background-color: ${theme.colors.primary};
        }
        :global(
            .rc-slider-handle,
            .rc-slider-handle:hover,
            .rc-slider-handle-focused,
            .rc-slider-handle-dragging
          ) {
          border-color: ${theme.colors.primary} !important;
        }
        :global(.rc-slider-handle-dragging) {
          border-color: ${theme.colors.primarypale} !important;
        }
        :global(.rc-slider-handle-dragging) {
          box-shadow: 0 0 0 5px ${theme.colors.primarypale} !important;
        }
        :global(.rc-slider-tooltip-arrow) {
          display: none;
        }
        :global(.rc-slider-tooltip-placement-top) {
          padding: 0;
        }
        :global(.rc-slider-tooltip-inner) {
          box-shadow: none;
          // padding: 0;
        }
        :global(.rc-slider-tooltip-inner) {
          background-color: ${theme.commoncolors.white};
          color: ${theme.commoncolors.greyshade};
        }
      `}</style>
    </>
  );
};

BookingRangeSlider.propTypes = {
  onRangeChange: PropTypes.func.isRequired,
  title: PropTypes.string,
};

export default BookingRangeSlider;
